import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'expenseTrash/state',
    initialState: {
        deleteConfirmation: false,
        recoverConfirmation: false,
        selectedExpense: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        toggleRecoverConfirmation: (state, action) => {
            state.recoverConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedExpense: (state, action) => {
            state.selectedExpense = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation,
    toggleRecoverConfirmation,
    setSortedColumn,
    setSelectedExpense
} = stateSlice.actions

export default stateSlice.reducer
